import React, { FC } from 'react'
import classNames from 'classnames'
import { Modal } from 'antd'
import { t } from '../util'
interface IProps {
  onLogout?: () => void
  locale: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "th" | "vie" | "fra" | "kor" | "fr"
  changeLanguage?: (value: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "th" | "vie" | "fra" | "kor" | "fr") => void
  openSettingModal: () => void
  resetMenuUI: () => void
  menuVisible: boolean
  subMenuVisible: boolean
  setMenuVisible: React.Dispatch<React.SetStateAction<boolean>>
  setSubMenuVisible: React.Dispatch<React.SetStateAction<boolean>>
}
const Menu: FC<IProps> = ({
  onLogout,
  locale,
  changeLanguage,
  openSettingModal,
  resetMenuUI,
  menuVisible,
  subMenuVisible,
  setMenuVisible,
  setSubMenuVisible,
}) => {
  const logout = () => {
    Modal.confirm({
      title: t('logoutConfirmText'),
      onOk: () => {
        onLogout?.()
      },
    })
  }
  return menuVisible ? (
    <div
      className={classNames('menu-wrapper', 'show-menu')}
      onMouseEnter={() => {
        setMenuVisible(true)
      }}
      onMouseLeave={resetMenuUI}
    >
      <div className="menu">
        {/* <div
          onClick={() => setSubMenuVisible(!subMenuVisible)}
          className={classNames('menu-item', {
            'menu-bg': subMenuVisible,
          })}
        >
          <i className="imiconfont language">&#xe728;</i>
          <div>{locale == 'zh' ? '中文' : 'English'}</div>
          <i className="imiconfont arrow">&#xe72d;</i>
        </div> */}
        <div className="menu-item" onClick={() => openSettingModal()}>
          <i className="imiconfont seeting">&#xe6d6;</i>
          <div>{t('settingText')}</div>
        </div>
        <div className="menu-item" onClick={() => logout()}>
          <i className="imiconfont logout">&#xe729;</i>
          <div>{t('logoutText')}</div>
        </div>
      </div>
      {/* <div
        className={classNames('sub-menu', {
          'show-sub-menu': subMenuVisible,
        })}
      >
        <div
          className={classNames('sub-menu-item', {
            active: locale === 'zh',
          })}
          onClick={() => {
            changeLanguage?.('zh')
            resetMenuUI()
          }}
        >
          中文
        </div>
        <div
          className={classNames('sub-menu-item', {
            active: locale === 'en',
          })}
          onClick={() => {
            changeLanguage?.('en')
            resetMenuUI()
          }}
        >
          English
        </div>
      </div> */}
    </div>
  ) : null
}

export default Menu
